module.exports = __webpack_public_path__ + "img/IMG-8797.a5b06f87.jpg";